import React, { Component } from "react";
import { Menu, Icon, List } from "semantic-ui-react";
// import Logo from "../assets/images/logos/elan-row.png";
import "../assets/styles/Footer.scss";
import { withUserContext } from "../components/ModalContext";
import {NavLink} from "react-router-dom";

class Footer extends Component {
  render() {
    return (<>
      <Menu
        style={{
          backgroundColor: "#f08d25",
          marginTop: "0px",
          marginBottom: "0px",
          paddingBottom: "0px",
            border:'none',
            borderRadius:'0',
        }}
      >
        <Menu.Item className={'left-menu'}>
          <List>
            <List.Item
              className={"socialMedia"}
              style={{ fontFamily: "'Paytone One', sans-serif" }}
            >
              SOCIAL MEDIA
            </List.Item>
            <List.Item className={"iconList"}>
              <a href="https://www.facebook.com/elan.iithyderabad">
                <Icon
                  className={"icon1"}
                  name="facebook square"
                  size="big"
                  style={{ color: "black" }}
                />
              </a>
              <a href="https://www.instagram.com/elan_nvision.iith/">
                <Icon
                  className={"icon2"}
                  name="instagram"
                  size="big"
                  style={{ color: "black" }}
                />
              </a>
              <a href="https://twitter.com/elan_nvision?lang=en">
                <Icon
                  className={"icon3"}
                  name="twitter"
                  size="big"
                  style={{ color: "black" }}
                />
              </a>
              <a href="https://www.youtube.com/user/ElanIITHyderabad">
                <Icon
                  className={"icon3"}
                  name="youtube"
                  size="big"
                  style={{ color: "black" }}
                />
              </a>
            </List.Item>
          </List>
        </Menu.Item>
        <Menu.Menu position="right" style={{ paddingTop: "0.5%" }}>
          <List>
            <List.Item
                as={NavLink}
                to={'/contact'}
              className={"footerText text1 footer-link"}
              position="right"
              style={{
                fontFamily: "'Paytone One', sans-serif",
                position: "absolute",
                right: "0",
                paddingRight: "1%",
                  color:'black'
              }}
            >
              CONTACT US
            </List.Item>
            <List.Item
              onClick={() => this.props.setShow(true)}
              className={"footerText text2"}
              position="right"
              style={{
                fontFamily: "'Paytone One', sans-serif",
                position: "absolute",
                right: "0",
                paddingRight: "1%",
                cursor: "pointer",
              }}
            >
              REGISTER
            </List.Item>
            <List.Item
                as={'a'}
                href={"https://drive.google.com/file/d/12bEcNHHRXseIuGKPDWVm5WEioimzSc5Q/view?usp=sharing"}
                target={'_blank'}
              className={"footerText text3"}
              position="right"
              style={{
                fontFamily: "'Paytone One', sans-serif",
                position: "absolute",
                right: "0",
                paddingRight: "1%",
                  color:'black',
              }}
            >
              FAQ'S
            </List.Item>
          </List>
        </Menu.Menu>

      </Menu>
        <Menu className={'copyright-menu'} >
            <Menu.Menu  className={'copyright'}>
                <h3>&#169; 2021 Elan and ηvision. All Rights Reserved.</h3>
            </Menu.Menu>
        </Menu>
    </>);
  }
}

export default withUserContext(Footer);
